import { render, staticRenderFns } from "./ysgInfo.vue?vue&type=template&id=dbb4d040&scoped=true"
import script from "./ysgInfo.vue?vue&type=script&lang=script"
export * from "./ysgInfo.vue?vue&type=script&lang=script"
import style0 from "./ysgInfo.vue?vue&type=style&index=0&id=dbb4d040&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb4d040",
  null
  
)

export default component.exports